import React, { useState } from "react";
import { Box, Typography, Alert, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import InvoiceList from "../components/Invoice/InvoiceList";
import InvoiceDialog from "../components/Invoice/InvoiceDialog";

/**
 * Invoice V1 Page (Read-only)
 * This page displays historical invoice submissions in read-only mode.
 * New submissions should be made using the Invoice V2 page.
 */
const InvoiceV1Page: React.FC = () => {
  const { t } = useTranslation();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [triggerGetInvoice, setTriggerGetInvoice] = useState<boolean>(false);

  const handleSubmit = async () => {
    setTriggerGetInvoice(!triggerGetInvoice);
    setDialogOpen(false);
  };

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        <Typography variant="h5">{t("invoice.v1.tab")}</Typography>
        <Button variant="contained" onClick={() => setDialogOpen(true)}>
          {t("invoice.new")}
        </Button>
      </Box>
      <Alert severity="info" sx={{ mb: 2 }}>
        {t("invoice.readOnlyMessage")}
      </Alert>

      <InvoiceList trigger={false} />

      <InvoiceDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        onSubmit={handleSubmit}
      />
    </Box>
  );
};

export default InvoiceV1Page;
